import { render, staticRenderFns } from "./ArticleSliderBNG.vue?vue&type=template&id=1dc45a85&scoped=true&"
import script from "./ArticleSliderBNG.vue?vue&type=script&lang=js&"
export * from "./ArticleSliderBNG.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSliderBNG.vue?vue&type=style&index=0&id=1dc45a85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc45a85",
  null
  
)

export default component.exports